
export default {
    props: {
        type: String,
        load: {
            type: Boolean,
            default: false
        },
        hideOnNoData: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Number,
            default: () => 1
        },
        titleIsCenter: {
            type: Boolean,
            default: () => true
        }
    },
    data () {
        return {
            form: new this.$vForm({}),
            files: null,
            noData: false
        }
    },
    computed: {
        storeFiles () {
            switch (this.type) {
            case 'added' :
                return this.$store.state.files.added
            case 'opened' :
                return this.$store.state.files.opened
            case 'noted' :
                return this.$store.state.files.noted
            case 'suggestion' :
                return this.$store.state.files.suggestion
            }
        }
    },
    mounted () {
        if (this.load) {
            this.loadData()
        } else if (this.storeFiles === null) {
            this.loadData()
        } else if (this.storeFiles.length <= 0) {
            this.noData = true
        }
    },
    methods: {
        async loadData () {
            const { data } = await this.form.get(this.localePath('/v1/files/' + this.getTypeRoute()), { params: { size: 16 } })
            if (this.load) {
                this.files = data
            } else {
                this.$store.commit('files/set' + (this.type.charAt(0).toUpperCase() + this.type.slice(1)), data)
            }
            if (data.length <= 0) {
                this.noData = true
            }
        },
        getTypeRoute () {
            switch (this.type) {
            case 'added' :
                return 'new'
            case 'opened' :
                return 'opened'
            case 'noted' :
                return 'highlighted'
            case 'suggestion':
                return 'suggestion'
            }
        },
        getLabel () {
            switch (this.type) {
            case 'added' :
                return this.$t('hxn new files')
            case 'opened' :
                return this.$t('hxn recent files')
            case 'noted' :
                return this.$t('hxn recently highlighted')
            case 'suggestion':
                return this.$t('hxn suggestion')
            }
        }
    }
}
